import React from 'react';
import { Crown, Star, Phone, MessageSquare, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle2 } from 'lucide-react';

export const PremiumPackageSection = ({ t }) => {
  if (!t || !t.premiumPackage || !t.premiumPackage.package) return null;

  const pkg = t.premiumPackage.package;
  const features = pkg.features || [];

  const handleContact = () => {
    window.location.href = 'tel:8194312712';
  };

  return (
    <section id="premium-package" className="py-20 bg-gradient-to-b from-black via-orange-900/10 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Crown className="h-16 w-16 text-orange-500 animate-pulse" />
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            {t.premiumPackage.title}
          </h2>
          <p className="text-2xl text-orange-500 font-bold mb-2">
            {t.premiumPackage.subtitle}
          </p>
        </div>

        <Card className="bg-gradient-to-br from-orange-500/20 via-stone-900 to-black border-4 border-orange-500 shadow-2xl shadow-orange-500/40 relative overflow-hidden">
          {/* Decorative stars background */}
          <div className="absolute top-4 right-4 flex gap-1 opacity-50">
            <Star className="h-8 w-8 text-orange-500 fill-orange-500" />
            <Star className="h-8 w-8 text-orange-500 fill-orange-500" />
            <Star className="h-8 w-8 text-orange-500 fill-orange-500" />
            <Star className="h-8 w-8 text-orange-500 fill-orange-500" />
            <Star className="h-8 w-8 text-orange-500 fill-orange-500" />
          </div>

          <CardHeader className="text-center pb-8 pt-12">
            <div className="bg-orange-500 text-white inline-block px-6 py-2 rounded-full mx-auto mb-4 font-bold text-sm">
              ULTRA EXCLUSIF - LIMITÉ À 4 FORFAITS PAR SAISON
            </div>
            <CardTitle className="text-4xl md:text-5xl text-orange-500 mb-4 font-bold">
              {pkg.name}
            </CardTitle>
            <p className="text-xl text-gray-300 mb-6 font-semibold">
              {pkg.description}
            </p>
            <div className="flex items-baseline justify-center mb-6">
              <span className="text-7xl font-bold text-white">${pkg.price}</span>
            </div>
          </CardHeader>

          <CardContent className="px-8 pb-10">
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="text-2xl font-bold text-orange-500 mb-4 flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-2" />
                  Inclusions Premium
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[0] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[1] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[2] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[3] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[4] || ''}</span></li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-orange-500 mb-4 flex items-center">
                  <Star className="h-6 w-6 mr-2 fill-orange-500" />
                  Avantages Exclusifs
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[5] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[6] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[7] || ''}</span></li>
                  <li className="flex items-start text-gray-200 text-lg"><CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-1" /><span className="font-medium">{features[8] || ''}</span></li>
                </ul>
              </div>
            </div>

            {/* Important Info Cards */}
            <div className="grid md:grid-cols-3 gap-4 mb-8">
              <div className="bg-orange-500/20 border border-orange-500 rounded-lg p-4 text-center">
                <AlertCircle className="h-8 w-8 text-orange-500 mx-auto mb-2" />
                <p className="text-white font-bold text-sm">{pkg.availability}</p>
              </div>
              
              <div className="bg-orange-500/20 border border-orange-500 rounded-lg p-4 text-center">
                <Crown className="h-8 w-8 text-orange-500 mx-auto mb-2" />
                <p className="text-white font-bold text-sm">{pkg.deposit}</p>
              </div>
              
              <div className="bg-green-500/20 border border-green-500 rounded-lg p-4 text-center">
                <Star className="h-8 w-8 text-green-500 mx-auto mb-2 fill-green-500" />
                <p className="text-green-400 font-bold text-sm">{pkg.note}</p>
              </div>
            </div>

            {/* Contact Buttons */}
            <div className="text-center">
              <p className="text-xl text-orange-500 font-bold mb-4">
                📞 {pkg.contact}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  onClick={handleContact}
                  className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-6 px-10 text-xl transition-all duration-300 hover:scale-105 shadow-2xl"
                >
                  <Phone className="mr-3 h-6 w-6" />
                  Appeler (819) 431-2712
                </Button>
                
                <Button
                  onClick={handleContact}
                  className="bg-green-600 hover:bg-green-700 text-white font-bold py-6 px-10 text-xl transition-all duration-300 hover:scale-105 shadow-2xl"
                >
                  <MessageSquare className="mr-3 h-6 w-6" />
                  Envoyer un Texto
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
